<h1 mat-dialog-title>ARBOL AST</h1>
<div mat-dialog-content>Se creo de forma exitosa el arbol AST</div>
<div mat-dialog-actions>
</div>